export default class DateTimeProvider {
  currentTimeMillis = () => new Date().getTime();
}